// frontend/src/api/baseClient.ts
import { API_BASE } from "./apiBase";

/** Thrown when the backend responds with 503 (DB unavailable). */
export class ServiceUnavailableError extends Error {
  constructor() {
    super("Service unavailable (503)");
    this.name = "ServiceUnavailableError";
  }
}

let tokenProvider: (() => Promise<string | null>) | null = null;

export function setTokenProvider(provider: () => Promise<string | null>) {
  tokenProvider = provider;
}

export async function apiFetch(
  path: string,
  options: RequestInit = {}
): Promise<Response> {
  // Determine headers
  const headers: Record<string, string> = {
    ...(options.headers as Record<string, string> | undefined),
  };

  let body = options.body;

  // Auto-stringify plain objects
  if (body && typeof body === "object" && !(body instanceof Blob) && !(body instanceof FormData) && !(body instanceof URLSearchParams)) {
    body = JSON.stringify(body);
    if (!headers["Content-Type"]) {
      headers["Content-Type"] = "application/json";
    }
  }

  if (tokenProvider) {
    try {
      const token = await tokenProvider();
      if (token) {
        headers["Authorization"] = `Bearer ${token}`;
      }
    } catch (e) {
      console.warn("[apiFetch] TokenProvider failed:", e);
    }
  }

  const response = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers,
    body,
  });

  if (response.status === 503) {
    throw new ServiceUnavailableError();
  }

  return response;
}